import { render, staticRenderFns } from "./MailCallbackWrapper.vue?vue&type=template&id=72c29d7c&scoped=true&"
import script from "./MailCallbackWrapper.vue?vue&type=script&lang=ts&"
export * from "./MailCallbackWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./MailCallbackWrapper.vue?vue&type=style&index=0&id=72c29d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c29d7c",
  null
  
)

export default component.exports